// 九一吃瓜首页静态数据（纯展示，不接真实事件，仅用于演示落地页文案）

export const CHANNELS = [
  "娱乐",
  "影视",
  "综艺",
  "科技",
  "体育",
  "财经",
  "社会",
  "电竞",
];

// 顶部更新条（压顶）
export const TICKER = [
  { time: "刚刚", tag: "娱乐", text: "某卫视跨年阵容名单流出 网友火速前排围观" },
  { time: "3分钟", tag: "综艺", text: "《一路向北》定档官宣 嘉宾海报引发热议" },
  { time: "8分钟", tag: "科技", text: "新一代旗舰发布在即 全网都在猜今晚定价" },
  { time: "12分钟", tag: "影视", text: "年度悬疑大剧放出新预告 首日播放量冲上热门" },
  { time: "18分钟", tag: "电竞", text: "总决赛名额敲定 粉丝开始预订观赛排面" },
  { time: "25分钟", tag: "财经", text: "跨界联名款上线秒空 二手价被抬上热门榜" },
];

// 今日新瓜速递（标题 + 短摘要列表）
export const TODAY_LIST = [
  {
    tag: "娱乐",
    time: "刚刚",
    title: "跨年阵容名单外泄 谁的咖位之争又刷屏了",
    summary: "一份没有盖章的演出名单在群里疯传，几个顶流同台的消息直接冲上热搜，前排吃瓜的已经搬好小板凳。",
  },
  {
    tag: "综艺",
    time: "6分钟",
    title: "综艺开播即翻红 观察室金句被剪成合集",
    summary: "新一季先导片播出后，观察室的临时反应片段被网友剪出多个神级名场面，播放量一路走高。",
  },
  {
    tag: "影视",
    time: "14分钟",
    title: "年度大剧预告上线 弹幕清一色在猜剧情",
    summary: "两分钟先导预告埋了三重伏笔，评论区从选角聊到结局，半天不到就盖出上千楼讨论帖。",
  },
  {
    tag: "科技",
    time: "20分钟",
    title: "旗舰新品发布倒计时 参数表已被提前翻烂",
    summary: "发布会还没开，各家渠道的配置表就在互通有无，网友表示今晚最大的瓜是定价到底香不香。",
  },
  {
    tag: "电竞",
    time: "26分钟",
    title: "决赛门票二次开售 抢购现场只剩手速比拼",
    summary: "首轮放票秒没之后二次补货，粉丝一边蹲抢一边在超话里互相打气，观赛热情持续升温。",
  },
  {
    tag: "财经",
    time: "35分钟",
    title: "联名款上架即售罄 二手市场坐地起价",
    summary: "限量联名早上十点上架，午间已显示缺货，二手平台上溢价行情被晒成新一轮围观素材。",
  },
  {
    tag: "社会",
    time: "42分钟",
    title: "一桩街头小事反转三次 网友直呼追不动",
    summary: "起因不过是一场小摩擦，半天内接连反转，评论区风向几度切换，吃瓜群众表示比追剧还累。",
  },
  {
    tag: "影视",
    time: "50分钟",
    title: "老剧重映热度不减 经典桥段又被人考古",
    summary: "某部经典老剧上线高清修复版，当年名场面被逐帧考古，弹幕里两代观众开始隔空对暗号。",
  },
];

// 热门前排围观（榜单）
export const HOT_RANK = [
  {
    rank: 1,
    tag: "综艺",
    title: "一档音乐综艺的导师阵容官宣 词条热度破亿",
    summary: "海报与先导片同步释出，导师互动片段被反复截图，节目还没录完就已经预定年度话题。",
    heat: "1280万",
  },
  {
    rank: 2,
    tag: "娱乐",
    title: "两位顶流同台路透 前排观众拍到同框现场",
    summary: "同台照一出，评论区从同框细节聊到行程重合，热度持续高走，网友调侃前排票买值了。",
    heat: "960万",
  },
  {
    rank: 3,
    tag: "科技",
    title: "新机首发拆解抢先曝光 内幕看点提前剧透",
    summary: "首发拆解视频流出，内部结构被逐层扒开，配置党与外观党隔空较劲，前排围观热度不减。",
    heat: "815万",
  },
  {
    rank: 4,
    tag: "体育",
    title: "赛季收官战终场绝杀 现场直击名场面",
    summary: "读秒阶段的绝杀镜头被慢放三遍，解说席一度语塞，赛后庆祝画面刷满整个讨论区。",
    heat: "742万",
  },
  {
    rank: 5,
    tag: "财经",
    title: "行业新规落地 从业者连夜排队在线问诊",
    summary: "细则一公布，各社群里刷屏提问，从门槛到流程都被拆成一条条干货转给同行，围观者众。",
    heat: "660万",
  },
  {
    rank: 6,
    tag: "社会",
    title: "暖闻刷屏 全网给这位平凡主角点赞",
    summary: "一件不起眼的小事被拍下后走红，评论区全是加油打气，正能量话题反而成了今日顶流。",
    heat: "583万",
  },
];

// 合集索引（更醒目）
export const COLLECTIONS = [
  {
    icon: "ri-calendar-event-line",
    name: "本周瓜报",
    desc: "每周六把一周新瓜按天打包，一次看完不漏课",
    count: "本周已收 32 条",
    accent: true,
  },
  {
    icon: "ri-file-list-3-line",
    name: "年度瓜田精选",
    desc: "从年初翻到年末的大事件精选，前排补课的入口",
    count: "收录 120 条",
  },
  {
    icon: "ri-live-line",
    name: "直播间名场面",
    desc: "直播翻车与高光时刻的图文现场合集",
    count: "收录 68 条",
  },
  {
    icon: "ri-movie-2-line",
    name: "影视剧综热议",
    desc: "热播剧、在播综艺的讨论脉络一键索引",
    count: "收录 96 条",
  },
  {
    icon: "ri-rocket-line",
    name: "科技圈新鲜事",
    desc: "发布会、新品与行业动向的快速围观入口",
    count: "收录 54 条",
  },
  {
    icon: "ri-briefcase-line",
    name: "商战第一线",
    desc: "价格、联名与人事变动，看热闹也看门道",
    count: "收录 41 条",
  },
];

// 分区速览（上疏下密的后段信息）
export const ZONES = [
  {
    zone: "娱乐",
    desc: "娱乐圈动态与话题发酵一手记录",
    items: [
      { title: "红毯造型盘点 全员上桌谁最出圈", summary: "红毯刚结束，造型图鉴已在热转" },
      { title: "综艺收官夜 成团名单引爆讨论", summary: "决赛直播名场面被反复回看" },
      { title: "演唱会巡演官宣 门票档期全公开", summary: "观众已经开始蹲抢票攻略" },
      { title: "新剧发布会 主创互cue全程有梗", summary: "现场花絮被剪成欢乐合集" },
    ],
  },
  {
    zone: "科技",
    desc: "新品发布与行业动向速递",
    items: [
      { title: "旗舰机发布 起售价成最大悬念", summary: "参数党配置党在线battle" },
      { title: "AI 新品亮相 现场演示惊呆全场", summary: "上手实测片段冲上热榜" },
      { title: "开源大模型更新 开发者连夜蹲测", summary: "评测数据刷屏各大社群" },
      { title: "智能穿戴换代 续航再度卷出新高度", summary: "真实用户反馈陆续出炉" },
    ],
  },
  {
    zone: "体育",
    desc: "赛场内外的高光与反转瞬间",
    items: [
      { title: "绝杀夜 主场观众集体沸腾", summary: "终场哨响后庆祝画面刷屏" },
      { title: "名宿解说翻车 弹幕全体玩梗", summary: "口误合集半天传遍全网" },
      { title: "新赛季揭幕 各队名单大换血", summary: "转会消息让前排忙不过来" },
      { title: "草根选手一夜成名 励志故事刷屏", summary: "平凡追梦获全网点赞" },
    ],
  },
  {
    zone: "社会",
    desc: "街头巷尾的真实热度现场",
    items: [
      { title: "暖闻刷屏 平凡瞬间最戳人", summary: "评论区全是暖心打气" },
      { title: "一件小事三次反转 追到结局才明白", summary: "网友直呼比剧集还精彩" },
      { title: "城市夜市的烟火气回来了", summary: "现场图直击人间热闹" },
      { title: "宠物成网红 每天蹲点看直播", summary: "萌宠合集播放量高得离谱" },
    ],
  },
];

// 图文现场直击（克制配图）
export const SCENES = [
  {
    img: "https://readdy.ai/api/search-image?query=Warm%20golden%20stage%20spotlight%20glowing%20over%20a%20crowd%20of%20silhouetted%20fans%20with%20phone%20lights%20held%20up%2C%20concert%20live%20broadcast%20atmosphere%2C%20cinematic%20warm%20tone%2C%20shallow%20depth%20of%20field%2C%20clean%20and%20vibrant%20entertainment%20scene&width=800&height=520&seq=gua-scene-01&orientation=landscape",
    tag: "娱乐现场",
    title: "演唱会巡演首站 万人场馆齐亮灯海",
    summary: "开嗓瞬间全场跟唱，前排机位记录下这片灯海，网友直呼这就是现场的魅力。",
    reads: "围观 128 万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Clean%20modern%20smartphone%20launch%20stage%20with%20a%20large%20screen%20showing%20new%20device%20silhouette%2C%20minimal%20dark%20auditorium%20with%20soft%20warm%20accent%20lighting%2C%20tech%20product%20presentation%20atmosphere%2C%20cinematic%20warm%20tones&width=800&height=520&seq=gua-scene-02&orientation=landscape",
    tag: "科技现场",
    title: "旗舰发布会现场 真机上手首亮相",
    summary: "真机登上展台的瞬间，前排掌声雷动，参数党与外观党第一次达成共识。",
    reads: "围观 96 万",
  },
  {
    img: "https://readdy.ai/api/search-image?query=Sports%20arena%20under%20bright%20stadium%20lights%20with%20celebrating%20crowd%20and%20confetti%2C%20final%20whistle%20moment%2C%20dynamic%20cinematic%20composition%2C%20warm%20evening%20glow%2C%20energetic%20and%20joyful%20live%20event%20scene&width=800&height=520&seq=gua-scene-03&orientation=landscape",
    tag: "赛场现场",
    title: "赛季收官绝杀 全场起立见证名场面",
    summary: "读秒阶段的一记绝杀点燃全场，现场图与慢放镜头交替刷屏，热度直接登顶。",
    reads: "围观 83 万",
  },
];